export default __webpack_public_path__ + "static/media/AQD.4bf33623.svg";